import handlebars from 'handlebars';
import $ from 'jquery';
import 'slick';
import { reloadPicturefillImagesWhenNeeded } from '../utils/generic-utilities.es6';
import { getPageType } from '../utils/gtm-utilities.es6';
import { pushGTMPersonalizationScrollItem } from './gtm-personalization-scrollItem.es6';
import { convertAlgoliaToGoogle, fetchRecos, getAlgoliaConf } from './algolia-utils.es6';
import { getCommonDataFromPageContext, maxNumberOfProducts, listName, moduleClass, getCatalogApiUrl, imgFormats, moduleTitle } from './certona-recommendation-v2-utils.es6';
import { fetchRandomRecommendations } from './random-recommendation.es6';

let handlebarHeader;
let handlebarBody;
let isHeaderCreatedFromCertonaData = false;
let swipeCounter = 0;
const slideData = [];
const slideDataGA4 = [];

const pagePath = window.location.pathname;
const pageType = getPageType(pagePath);
const countryUrl = pagePath.split('/')[1];
const languageUrl = pagePath.split('/')[2];
const countryLanguage = `/${countryUrl}/${languageUrl}`;
const baseLanguage = languageUrl === undefined ? '' : languageUrl.split('_')[0];

const setupInfo = {
    currency: '',
    lang: '',
    getPrice: false,
    getLocale: false
};

if (RegExp('uk|it|de|fr|es|ch|at|be|ie|nl|dk|fi|no|se|cz|hu|pl|pt|si|bg|ro|tr|ae|qa|sa|kw|kr|sg|th|za|gr|lu').test(countryUrl)) {
    setupInfo.currency = 'GBP';
    setupInfo.lang = 'en-uk';
    if (baseLanguage !== 'en') {
        setupInfo.getLocale = true;
    }
    if (!RegExp('uk').test(countryUrl)) {
        setupInfo.getPrice = true;
    }
} else if (RegExp('hk').test(countryUrl)) {
    setupInfo.currency = 'HKD';
    if (baseLanguage === 'en') {
        setupInfo.lang = 'en-hk';
    }
    if (baseLanguage === 'zh') {
        setupInfo.lang = 'zh-hk';
    }
    if (languageUrl === 'zh') {
        setupInfo.getLocale = true;
    }
} else if (RegExp('jp').test(countryUrl)) {
    setupInfo.currency = 'JPY';
    setupInfo.lang = 'ja-jp';
    setupInfo.getPrice = true;
    if (baseLanguage !== 'ja') {
        setupInfo.getLocale = true;
    }
} else if (RegExp('au|nz').test(countryUrl)) {
    setupInfo.currency = 'AUD';
    setupInfo.lang = 'en-au';
    if (baseLanguage !== 'en') {
        setupInfo.getLocale = true;
    }
    if (RegExp('nz').test(countryUrl)) {
        setupInfo.getPrice = true;
    }
} else if (RegExp('us|ca|mx').test(countryUrl)) {
    setupInfo.currency = 'USD';
    setupInfo.lang = 'en-us';
    if (baseLanguage !== 'en') {
        setupInfo.getLocale = true;
    }
    if (countryUrl !== 'us') {
        setupInfo.getPrice = true;
    }
}

let viewType = '';

if (RegExp('-p-').test(pagePath)) {
    viewType = 'product';
} else if (RegExp('wishlist').test(pagePath)) {
    viewType = 'wishlist';
} else if (RegExp('cart').test(pagePath)) {
    viewType = 'basket';
}

const catalogApiUrl = getCatalogApiUrl();

function bindVariables() {
    handlebarHeader = handlebars.compile((document.getElementById('certonaRecommendation_v2-header-template') || {}).innerHTML || '');
    handlebarBody = handlebars.compile((document.getElementById('certonaRecommendation_v2-body-template') || {}).innerHTML || '');
    isHeaderCreatedFromCertonaData = document.querySelector(moduleClass).getAttribute('data-component-type') === 'generic';
}

const createImageFromStringGoogle = img => {
    let _images = '';
    for (let i = 0; i < Object.keys(imgFormats).length; i++) {
        if (img.indexOf('DarkGray_Center_0_0_2400x2400') >= 0) {
            _images += img.replace('DarkGray_Center_0_0_2400x2400', imgFormats[Object.keys(imgFormats)[i]]);
        }
        if (img.indexOf('White_Center_0_0_2400x2400') >= 0) {
            _images += img.replace('White_Center_0_0_2400x2400', imgFormats[Object.keys(imgFormats)[i]]);
        }
        if (i !== Object.keys(imgFormats).length - 1) _images += ',';
    }

    const images = _images.split(',').map(url => url.trim().replace('http:', ''));

    // eslint-disable-next-line camelcase
    const [src_small, src_medium, src_small_retina, src_medium_retina, src_standard_retina] = images;

    // check 'imageFormatMappingForCrossSellProductsforHover'
    return {
        src_medium_retina,
        src_small_retina,
        src_standard_retina,
        src_medium,
        src_small,
        src_standard: src_small_retina,
        src: src_small_retina
    };
};

const createItemGoogle = array => {
    const arr = [];

    for (let i = 0; i < array.length; i++) {
        arr.push({
            price: array[i].price.split(' ')[1],
            full_price: array[i].price.split(' ')[1],
            main_category: '',
            name: array[i].name,
            standardImage: createImageFromStringGoogle(array[i].position1_image),
            alternativeImage: createImageFromStringGoogle(array[i].position2_image),
            style: array[i].id,
            url: array[i].url
        });
    }

    return arr;
};

const sanitizeGoogle = array => ({
    resonance: {
        schemes: [
            {
                scheme: 'googleRec',
                display: 'yes',
                title: moduleTitle[languageUrl],
                currency: window.currencyData.symbol,
                items: createItemGoogle(array)
            }
        ]
    },
    pagetype: pageType
});

const productInfo = (data, url, _pageURL = pagePath, _pageType = pageType) => {
    const priceData = data.price;
    const priceClear = priceData.replace(/[,.]/g, '');
    return {
        price: priceClear,
        position: data.position,
        name: data.name,
        list: data.listName,
        id: data.styleId,
        ...getCommonDataFromPageContext(url, _pageURL, _pageType)
    };
};

const productInfoGA4 = (data, url) => {
    const priceData = data.price;
    const priceClear = priceData.replace(/[,.]/g, '');
    return {
        item_list_name: data.listName,
        item_id: data.styleId,
        item_brand: 'unknown',
        item_name: data.name,
        currency: data.currency,
        index: data.position,
        item_category: url,
        item_variant: '',
        price: priceClear,
        quantity: '1'
    };
};

const productListToImpressions = productList => {
    productList.forEach((item, index) => {
        if (document.documentElement.clientWidth > 1023 || (document.documentElement.clientWidth > 399 && document.documentElement.clientWidth < 1024) || document.documentElement.clientWidth < 400) {
            slideData[index] = productInfo(item.dataset, item.href);
        }
    });

    return slideData;
};

const productListToViewItems = productList => {
    productList.forEach((item, index) => {
        if (document.documentElement.clientWidth > 1023 || (document.documentElement.clientWidth > 399 && document.documentElement.clientWidth < 1024) || document.documentElement.clientWidth < 400) {
            slideDataGA4[index] = productInfoGA4(item.dataset, item.href);
        }
    });

    return slideDataGA4;
};

const pushProductDataToGtmEvents = activeSlide => {
    window.dataLayer.push({
        event: 'productImpression',
        ecommerce: {
            impressions: productListToImpressions(activeSlide)
        }
    });
    try {
        window.analyticsSdk.tracking.sendEvent({
            name: 'view_item_list',
            event: {
                event: 'view_item_list',
                country: window.location.pathname.split('/')[1],
                language: window.location.pathname.split('/')[2],
                item_list_id: pagePath,
                item_list_name: listName,
                items: productListToViewItems(activeSlide)
            }
        });
    } catch (e) {
        console.error('Problem with Analytics SDK: unable to track view_item_list');
    }
};

const checkCarouselActiveItems = event => {
    const activeSlide = document.querySelectorAll('.certona-recommendation-v2 .slick-active a');

    // TODO: ask the analytics team what is the expectation to differ the 2 types
    if (event.type === 'init') {
        pushProductDataToGtmEvents(activeSlide);
    } else if (event.type === 'afterChange' && swipeCounter > 0) {
        pushProductDataToGtmEvents(activeSlide);
    }

    swipeCounter = event.type === 'init' ? 0 : swipeCounter + 1;
};

const trackCarouselVisibility = () => {
    window.GTMuaEventsPusher('nonInteractionEvent', 'cross-sell', 'products displayed', viewType);
    document.dispatchEvent(new Event('CrossSellComponentRendered'));
};

const initializeCarousel = (certonaHeader, certonaBody) => {
    const slickConfigs = {
        arrows: false,
        dots: false,
        mobileFirst: true,
        centerMode: true,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 400, // also smartphone in landscape
                settings: {
                    slidesToShow: 2,
                    initialSlide: 0,
                    centerMode: false
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    infinite: false,
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const $carousel = $(certonaBody.querySelector('.carousel-inner'));

    function removeAriaDescribedByAttributeThatRefersToAMissingElement(slick) {
        function isPresent(ariaDescribedById) {
            return ariaDescribedById && $(`#${ariaDescribedById}`).length === 0;
        }

        slick.$slides.not(slick.$slideTrack.find('.slick-cloned')).each(function() {
            if (isPresent($(this).attr('aria-describedby'))) {
                $(this).removeAttr('aria-describedby');
            }
        });
    }

    if (isHeaderCreatedFromCertonaData) {
        certonaHeader.querySelectorAll('.certona-recommendation-v2__header-list-button').forEach(button => {
            button.addEventListener('click', () => {
                const schema = this.getAttribute('data-schema');
                const slickElement = certonaBody.querySelector(`.certona-recommendation-v2__slide:not(.slick-cloned)[data-schema="${schema}"]`);
                $carousel.slick('slickGoTo', slickElement.getAttribute('data-slick-index'));
            });
        });

        $carousel.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const selectedSchema = certonaBody.querySelector(`[data-slick-index="${nextSlide}"]`).getAttribute('data-schema');
            certonaHeader.querySelectorAll(`[data-schema]`).forEach(elm => elm.classList.remove('selected'));
            certonaHeader.querySelector(`[data-schema="${selectedSchema}"]`).classList.add('selected');
        });
    }
    $carousel
        .on('init', (event, slick) => {
            const certonaElement = document.querySelector(`${moduleClass} .certona-recommendation-v2`);
            certonaElement.classList.add('visible');
            performance.mark('certona-recommendation-v2-carousel-visible');
            reloadPicturefillImagesWhenNeeded(certonaElement, true);
            slick.refresh();
            checkCarouselActiveItems(event);
        })
        .on('setPosition', (event, slick) => {
            removeAriaDescribedByAttributeThatRefersToAMissingElement(slick);
        })
        .on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            window.dataLayer.push({
                event: 'certona.swipe'
            });
            if (nextSlide !== currentSlide) {
                pushGTMPersonalizationScrollItem();
            }
        })
        .on('afterChange', event => {
            checkCarouselActiveItems(event);
        })
        .slick(slickConfigs);

    trackCarouselVisibility();
};

const finalizeGoogle = array => {
    bindVariables();

    const sanitizedData = sanitizeGoogle(array);

    const certonaHeader = document.querySelector(`${moduleClass} .certona-recommendation-v2__header`);

    if (isHeaderCreatedFromCertonaData) {
        certonaHeader.innerHTML = handlebarHeader(sanitizedData);
    }

    const certonaBody = document.querySelector(`${moduleClass} .certona-recommendation-v2__body`);
    certonaBody.innerHTML = handlebarBody(sanitizedData);

    initializeCarousel(certonaHeader, certonaBody);
};

const removeProductsWithoutPrice = products => {
    let x = 0;
    while (x < products.length) {
        if (!products[x].price) {
            products.splice(x, 1);
        } else {
            x += 1;
        }
    }
};

const getStylesPrices = products => {
    const _products = products;
    const pricePromises = products.map(product => {
        const _product = product;
        return fetch(`${countryLanguage}/p/ajax/product-detail-price.json?productCode=${product.id}`)
            .then(response => (response.ok ? response.json() : null))
            .then(price => {
                _product.price = price?.currentPrice;
            });
    });

    return Promise.all(pricePromises).then(() => {
        removeProductsWithoutPrice(_products);
    });
};

const setStyleNames = (products, productResponse) => {
    const _products = products;
    for (let x = 0; x < _products.length; x++) {
        const tr = productResponse[_products[x].id].translations;
        for (let i = 0; i < tr.length; i++) {
            if (tr[i].language.toLowerCase() === languageUrl) {
                _products[x].name = tr[i].name;
            }
        }
    }
};

const getStylesNames = products => {
    const styleCodes = products.map(product => product.id);

    return fetch(`https://${catalogApiUrl}/v1/batch/products`, {
        method: 'POST',
        body: JSON.stringify({
            styleCodes
        })
    })
        .then(response => (response.ok ? response.json() : null))
        .then(responseBody => {
            if (responseBody) {
                setStyleNames(products, responseBody);
            }
        });
};

const startRecommendations = recs => {
    if (recs === null || recs.length === 0) {
        console.log('No recommendations to display');
        return;
    }

    const _products = [];
    for (let p = 0; p < recs.length; p++) {
        if (p < maxNumberOfProducts) {
            const _url = recs[p].details.url;
            const priceWithNoCents = Number(recs[p].details.unit_price);
            _products.push({
                id: recs[p].id,
                name: recs[p].details.name,
                url: _url.replace('http:', 'https:').replace(
                    _url
                        .split('www.gucci.com')[1]
                        .split('/', 3)
                        .join('/'),
                    countryLanguage
                ),
                price: `${window.currencyData.symbol} ${priceWithNoCents}`,
                position1_image: recs[p].details.image_url,
                position2_image: recs[p].details.image_url.replace('_001_', '_002_')
            });
        }
    }

    const promises = [];
    if (setupInfo.getLocale) {
        promises.push(getStylesNames(_products));
    }
    if (setupInfo.getPrice) {
        promises.push(getStylesPrices(_products));
    }

    Promise.all(promises).then(() => finalizeGoogle(_products));
};

async function fetchAlgoliaRecos(_countryLanguage, _pagePath, _styleCode) {
    const _data = await fetchRecos(getAlgoliaConf(), _styleCode);
    if (_data === undefined) {
        return Promise.reject(new Error('fetched failed'));
    }
    const converted = convertAlgoliaToGoogle(_data, _countryLanguage, _pagePath);
    if (converted === undefined) {
        return Promise.reject(new Error('convert failed'));
    }
    return converted;
}

const getRandomRecommendations = () => {
    fetchRandomRecommendations(countryUrl, languageUrl, countryLanguage, pagePath)
        .then(res => startRecommendations(res))
        // logs handled already.
        .catch(err => {
            console.error(err);
        });
};

// this function is a placeholder for running optimizely experimentations
const recommendationProviderResolver = () => {
    if (pageType === 'Wishlist' || pageType === 'Shopping Bag') {
        getRandomRecommendations();
    }
};

const pollGeneralPageInformation = () => {
    const personalizationEnabledPoller = setInterval(() => {
        clearInterval(personalizationEnabledPoller);
        recommendationProviderResolver();
    }, 200);
};

export const POLLER = pollGeneralPageInformation();

export const recommendation = {
    startRecommendations
};

export const productInfoModule = {
    productInfo
};

export const refreshCrossSelling = () => {
    recommendationProviderResolver();
};

export const GoogleAnalyticsDataConverter = {
    productListToImpressions,
    productListToViewItems
};

export const algoliaRecos = {
    fetchAlgoliaRecos
};
